﻿import $ from 'jquery';
$(document).on('ready', function () {
  // initialization of header
  $.HSCore.components.HSHeader.init($('#header'));

  // initialization of unfold component
  $.HSCore.components.HSUnfold.init($('[data-unfold-target]'), {
    afterOpen: function () {
      if (!$('body').hasClass('IE11')) {
        $(this).find('input[type="search"]').focus();
      }
    }
  });

  // initialization of forms
  $.HSCore.helpers.HSFocusState.init();

  // initialization of malihu scrollbar
  //$.HSCore.components.HSMalihuScrollBar.init($('.js-scrollbar'));

  // initialization of autonomous popups
  $.HSCore.components.HSModalWindow.init('[data-modal-target]', '.js-signup-modal', {
    autonomous: true
  });

  // initialization of show animations
  $.HSCore.components.HSShowAnimation.init('.js-animation-link');

  // initialization of slick carousel
  $.HSCore.components.HSSlickCarousel.init('.js-slick-carousel');

  // initialization of fancybox
  //$.HSCore.components.HSFancyBox.init('.js-fancybox');

  // initialization of go to
  $.HSCore.components.HSGoTo.init('.js-go-to');

  jarallax(document.querySelectorAll('.jarallax'));

  jarallax(document.querySelectorAll('.jarallax-keep-img'), {
    keepImg: true,
  });

  var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function(form) {
      form.addEventListener('submit', function(event) {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });

});